import api from 'Application/api/api';
import adaptClientRequestData from 'Client/api/adapters/adaptClientRequestData';
import adaptClientResponseData from 'Client/api/adapters/adaptClientResponseData';

const editClient = async (signal, values) => {
	const response = await api.put('/clients', adaptClientRequestData(values), {
		signal,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
		data: adaptClientResponseData(response.data),
	};
};

export default editClient;
